
// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './slices/persister'; // ✅ use persisted store
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}> {/* ✅ correct store used */}
        <PersistGate loading={null} persistor={persistor}>
            <HashRouter basename={process.env.PUBLIC_URL}>
                <App />
            </HashRouter>
        </PersistGate>
    </Provider>
);

reportWebVitals();

